<template>
  <main class="Rechargeaa">
    <div id="Rechargeing">
      <img
        src="../assets/logo.png"
        class="logsa"
        @click="$router.push('/Home')"
      />
      <div class="Rechargeing">
        <!-- <div class="headerr">
          <div class="o1">
            <img draggable="false" src="../../static/percttent/hxd.png" />

            <span>
              <i>1海星点/2元</i>
              <i>3点/小时</i>
            </span>
          </div>
          <div class="o2">
            <p>玩家正式登录平台起开始智能计费。</p>
            <p>以分钟为单位扣费，每10分钟扣1海星点，不足10分钟以10分钟扣费。</p>
            <p>
              充值即表示您已阅读并同意
              <a @click="zhucexieyi = true">《星瀛科技在线服务协议》</a>
            </p>
            <i>每晚2:00到次日10:00点，海星云半价优惠，仅需3海星点/小时。</i>
          </div>
        </div>-->
        <div class="rech">
          <!-- <div class="oa1">
            <span class="fl">余额：{{ yue }}</span>

            <a @click="Returngo" class="u-btnzx fr">返回</a>
          </div>-->
          <!-- <p class="payzh">充值账号：{{ username }}</p> -->
          <div class="pay">
            <ul>
              <li
                v-for="(i, index) in paylist"
                :key="index"
                @click="paypay(i, index)"
                :style="i.style"
                v-show="i.flag == 1"
              >
                <a>
                  <img draggable="false" :src="i.img" />
                </a>
                <img
                  :src="i.chaozhi"
                  alt
                  style="position: absolute; top: -4px; right: 15px; z-index: 1"
                />
                <a v-show="index == czbord">
                  <img
                    draggable="false"
                    :src="i.kuang"
                    alt
                    style="
                      width: 50px;
                      height: 50px;
                      position: absolute;
                      top: 160px;
                      right: 5px;
                    "
                  />
                </a>
                <b v-html="i.miaoshu" style="text-align: center">
                  {{ i.miaoshu }}
                </b>
              </li>

              <li
                v-show="zhoukaka"
                v-for="(i, index) in zklist"
                :key="index"
                @click="zhouka(i, index)"
              >
                <a>
                  <img draggable="false" :src="i.img.split('***')[0]" />
                </a>
                <a v-show="index == zkbord">
                  <img
                    draggable="false"
                    src="../../static/images/chonzghi/kuang.png"
                    alt
                    style="
                      width: 50px;
                      height: 50px;
                      position: absolute;
                      top: 160px;
                      right: 5px;
                    "
                  />
                </a>
                <b style="text-align: center">{{ i.desc }}</b>
              </li>
            </ul>
            <ul v-show="zhoukaka2"></ul>
          </div>
          <div class="payfangshi">
            <div class="wechat">
              <span> <i style="color: rgb(255, 204, 0)">▎</i>支付方式： </span>
              <div>
                <div id="qrcode"></div>
                <div class="saoma">
                  <div>
                    <img
                      draggable="false"
                      src="../assets/images/weixinzhifu.png"
                    />
                    <p>
                      <i>微信扫一扫</i>
                      <i>完成支付</i>
                    </p>
                  </div>
                  <div>
                    <img
                      draggable="false"
                      src="../assets/images/zhifubaozhifu.png"
                    />
                    <p>
                      <i>支付宝扫一扫</i>
                      <i>完成支付</i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="miaoshu">
            <ul>
              <li style=" color:#e60012">
                非高峰周卡、非高峰月卡使用时间：&#8195; 周一至周五 凌晨2点至19点。
                <br />
              </li>
              <li style=" color:#e60012">
                晚间繁忙时段 19：00至24:00 和
                周六、周日，非高峰周卡非高峰月卡不可使用，该时间段系统依照原有扣费机制扣除海星点。
              </li>
              <li>本平台支持游戏挂机机制。退出平台或切出页面，请关闭客户端，否则默认为挂机行为将持续计费。</li>
              <li>用户理解并同意，充值产品虚拟货币不适用无理由退换，充值一旦成功，充值即确定完成，星瀛科技将不提供任何更改、修正服务。用户不得以消费完成后账户内仍有剩余海星点为由要求退费。</li>
              <li>当用户在本平台进行充值时，用户必须仔细确认自己的账号及信息，若因为用户自身操作不当、不了解或未充分了解充值计费方式等因素造成充错账号、错选充值种类等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。</li>
            </ul>
          </div>-->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  clearInterval
} from 'timers'
// import adaption from '@/mixi/adaption'
export default {
  // mixins: [adaption],
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [{
      name: 'keywords',
      content: '充值中心,海星点,云游戏:海星云平台,海星云,云游戏,5G云游戏,海星云主机,海星云电脑,海星云2080ti,云平台,星瀛科技,星瀛云,4K高清游戏,手机玩电脑游戏,移动端steam,移动端3A,下载牛牛游戏,牛牛游戏下载,牛牛游戏大厅,网络游戏,好玩的游戏,权利的游戏,网易游戏'
    },
    {
      name: 'description',
      content: '作为硬核玩家与极客团队，创造了星瀛科技（北京）有限公司，融入5G时代新应用产业的发展，自主研发高性能“海星云”云游戏平台，提供软硬件综合解决方案，让伙伴们不再是云玩家，在任意时间、任意地点、任意设备，共享高画质流畅体验。未来，我们的征途是星辰大海，勇气与胸怀是我们踏上远方的陪伴，迈向星河彼岸，须弥胜境。-充值中心,海星点'
    }
    ]
  },
  data () {
    return {
      ci: '1',
      zhoukaka: true,
      nonono: false,
      token: '',
      zkimg: [],
      zklist: [],
      flag: true,
      Return: './../../static/images/icon/Return.png',
      zhucexieyi: false,
      check: true,
      username: '',
      yue: '',
      huiyuan: '',
      saoma: '微信',
      id: '',
      czbord: 0,
      zkbord: -1,
      erweimasj: '',
      dingdanhao: '',
      zfbdingdanhao: '',
      time: null,
      morenid: '',
      paylist: [
        {
          // 一次性充值600元获得900海星点，原价900元，相当于
          img: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/600.png',
          kuang: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/kuang.png',
          chaozhi: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/tuijian.png',
          miaoshu: '',
          qian: 600,
          dian: 900,
          id: 9,
          flag: 1
        },
        {
          // 一次性充值200元获得240海星点，原价240元，相当
          img: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/200.png',
          kuang: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/kuang.png',
          miaoshu: '',
          qian: 200,
          dian: 240,
          id: 7,
          // style:"margin-right:40px",
          flag: 1
        },
        {
          // 一次性充值50元获得50点，相当于
          img: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/50.png',
          kuang: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/kuang.png',
          miaoshu: '',
          qian: 50,
          dian: 50,
          id: 6,
          // style:"margin-right: 0px",
          flag: 1
        },
        {
          // 一次性充值20元获得20点，相当于
          img: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/20.jpg',
          kuang: 'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/zhouka/kuang.png',
          miaoshu: '',
          qian: 20,
          dian: 20,
          id: 11,
          // style:"margin-right:40px",
          flag: 1
        }
      ]
    }
  },
  methods: {
    // 周卡
    zhouka (i, index) {
      if (this.check == false) {
        this.$message.error('请阅读并同意《星瀛科技在线服务协议》')
        return false
      } else {
        if (i.counts == 1) {
          this.$message.error('时长卡仅限VIP2以上会员购买')
        } else {
          $('#qrcode').empty() // 清空二维码
          this.zkbord = index
          this.czbord = -1
          this.http.erweima('wechat', i.id, 2).then(res => {
            this.erweimasj = res.data.data.payurl
            this.dingdanhao = res.data.data.outtradeno
            this.$QRCodeSC(res.data.data.payurl, 200, 200)
            if (res.status == 200) {
              var time = setInterval(() => {
                // 查询充值状态
                this.http.cxerweima(this.dingdanhao).then(res => {
                  if (res.data.code == 200) {
                    if (res.data.message == 'ok') {
                      this.$router.push({
                        path: './center',
                        query: {
                          route: 1
                        }
                      })
                      window.clearInterval(time)
                      this.$router.go(0)
                    }
                  }
                })
              }, 1000)
            }
          })
          this.http.erweima('alipay', i.id, 2).then(res => {
            this.erweimasj = res.data.data.payurl
            this.dingdanhao = res.data.data.outtradeno
            this.$QRCodeSC(res.data.data.payurl, 200, 200)
            if (res.status == 200) {
              var time = setInterval(() => {
                // 查询充值状态
                this.http.cxerweima(this.dingdanhao).then(res => {
                  if (res.data.code == 200) {
                    if (res.data.message == 'ok') {
                      this.$router.push({
                        path: './center',
                        query: {
                          route: 1
                        }
                      })
                      window.clearInterval(time)
                      this.$router.go(0)
                    }
                  }
                })
              }, 1000)
            }
          })
        }
      }
    },
    // 购买海星点前，选择不同金额逻辑  (可能有其他逻辑，暂未细看)
    paypay (i, index) {
      if (this.check == false) {
        this.$message.error('请阅读并同意《星瀛科技在线服务协议》')
        return false
      } else {
        var wechat_outtradeno
        $('#qrcode').empty() // 清空二维码
        this.czbord = index
        this.zkbord = -1
        this.http.erweima('wechat', i.id, 1).then(res => {
          console.log('wechat', i.id, 1, '微信支付方式')
          this.erweimasj = res.data.data.payurl
          this.dingdanhao = res.data.data.outtradeno
          this.$QRCodeSC(res.data.data.payurl, 200, 200)
          if (res.status == 200) {
            wechat_outtradeno = this.dingdanhao
          }
        })
        this.http.erweima('alipay', i.id, 1).then(res => {
          this.erweimasj = res.data.data.payurl
          this.dingdanhao = res.data.data.outtradeno
          this.$QRCodeSC(res.data.data.payurl, 200, 200)
          if (res.status == 200) {
            var time = setInterval(() => {
              // 查询微信的充值状态
              this.http.cxerweima(this.dingdanhao).then(res => {
                if (res.data.code == 200) {
                  if (res.data.message == 'ok') {
                    this.$router.push('./center')
                    window.clearInterval(time)
                    this.$router.go(0)
                  }
                }
              })
              // 查询支付宝的充值状态
              this.http.cxerweima(wechat_outtradeno).then(res => {
                if (res.data.code == 200) {
                  if (res.data.message == 'ok') {
                    this.$router.push('./center')
                    window.clearInterval(time)
                    this.$router.go(0)
                  }
                }
              })
            }, 1000)
          }
        })
      }
    },
    // 返回首页逻辑
    Returngo () {
      if (this.$route.query.information == 1) {
        this.$router.push({
          path: './center'
        })
      } else if (this.$route.query.card == 1) {
        this.$router.push({
          path: './center',
          query: {
            route: 1
          }
        })
      } else {
        this.$router.push('./Home')
      }
    }
  },
  // 如果没有登陆，那么就跳转到首页，不允许进入充值页面
  created () {
    this.token = this.$cookieStore.getCookie('user_sess')
    if (!this.token) {
      this.$router.push({
        path: './SignIn',
        query: {
          flag: 1
        }
      })
    }
  },
  mounted () {
    // setTimeout(() => console.log(this.zklist), 2000)
    // 购买海星卡等产品
    this.http.GERENZX(this.token).then(res => {
      // if(res.data.data.vip_level>=2){
      //     this.zhoukaka = true
      // }else{
      //     this.zhoukaka = false
      // }
      if (res.data.data.vip_level >= 4) {
        this.paylist[0].flag = 1
        this.czbord = 0
        this.morenid = 10
        this.http.erweima('wechat', this.paylist[0].id, 1).then(res => {
          this.erweimasj = res.data.data.payurl
          this.dingdanhao = res.data.data.outtradeno
          this.$QRCodeSC(res.data.data.payurl, 200, 200)
          if (res.status == 200) {
            var time = setInterval(() => {
              // 查询充值状态
              this.http.cxerweima(this.dingdanhao).then(res => {
                if (res.data.code == 200) {
                  if (res.data.message == 'ok') {
                    this.$router.push('./center')
                    window.clearInterval(time)
                    this.$router.go(0)
                  }
                }
              })
            }, 1000)
          }
        })
        this.http.erweima('alipay', this.paylist[0].id, 1).then(res => {
          this.erweimasj = res.data.data.payurl
          this.dingdanhao = res.data.data.outtradeno
          this.$QRCodeSC(res.data.data.payurl, 200, 200)
          if (res.status == 200) {
            var time = setInterval(() => {
              // 查询充值状态
              this.http.cxerweima(this.dingdanhao).then(res => {
                if (res.data.code == 200) {
                  if (res.data.message == 'ok') {
                    this.$router.push('./center')
                    window.clearInterval(time)
                    this.$router.go(0)
                  }
                }
              })
            }, 1000)
          }
        })
      } else {
        this.paylist[0].flag = 0
        // this.paylist[2].style = "margin-right:40px"
        // this.paylist[3].style = "margin-right:0px"
        this.czbord = 1
        this.morenid = 9
        this.http.erweima('wechat', 7, 1).then(res => {
          this.erweimasj = res.data.data.payurl
          this.dingdanhao = res.data.data.outtradeno
          this.$QRCodeSC(res.data.data.payurl, 200, 200)
          if (res.status == 200) {
            var time = setInterval(() => {
              // 查询充值状态
              this.http.cxerweima(this.dingdanhao).then(res => {
                if (res.data.code == 200) {
                  if (res.data.message == 'ok') {
                    this.$router.push('./center')
                    window.clearInterval(time)
                    this.$router.go(0)
                  }
                }
              })
            }, 1000)
          }
        })
        this.http.erweima('alipay', 7, 1).then(res => {
          this.erweimasj = res.data.data.payurl
          this.dingdanhao = res.data.data.outtradeno
          this.$QRCodeSC(res.data.data.payurl, 200, 200)
          if (res.status == 200) {
            var time = setInterval(() => {
              // 查询充值状态
              this.http.cxerweima(this.dingdanhao).then(res => {
                if (res.data.code == 200) {
                  if (res.data.message == 'ok') {
                    this.$router.push('./center')
                    window.clearInterval(time)
                    this.$router.go(0)
                  }
                }
              })
            }, 1000)
          }
        })
      }
      // this.username = res.data.data.phone
      // this.yue = res.data.data.userbalance
      // var huiyuan = res.data.data.vip_level
      // console.log(res)
      // if (huiyuan == 0) {
      //   this.huiyuan = ''
      // } else if (huiyuan == 1) {
      //   this.huiyuan = '../../static/images/center/VIP1.png'
      // } else if (huiyuan == 2) {
      //   this.huiyuan = '../../static/images/center/VIP2.png'
      // } else if (huiyuan == 3) {
      //   this.huiyuan = '../../static/images/center/VIP3.png'
      // } else if (huiyuan == 4) {
      //   this.huiyuan = '../../static/images/center/VIP4.png'
      // } else if (huiyuan == 5) {
      //   this.huiyuan = '../../static/images/center/VIP5.png'
      // } else if (huiyuan == 6) {
      //   this.huiyuan = '../../static/images/center/VIP6.png'
      // }
    })
    // 拿到周卡等产品
    this.http.CXZKOUKA(this.token).then(res => {
      this.zklist = res.data.data.timecard_list
      if (this.zklist[0].counts == 1) {
        this.ci = 0
      } else {
        this.ci = 1
      }
    })
  }
}
</script>

<style lang="scss">
.pay img {
  pointer-events: none;
}
#Rechargeing {
  width: 100%;
  background: rgba(43, 55, 87, 1);
  color: #fff;

  .logsa {
    display: block;
    width: 300px;
    margin: 0 auto;
    padding: 40px 0;
  }

  .Rechargeing {
    width: 1100px;
    margin: 0 auto;

    .headerr {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #fff;
      border-radius: 10px;
      background: rgba(156, 165, 236, 0.1);
      padding: 30px;

      .o1 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 25px;

        i {
          display: block;
          color: #f6d200;
          padding-left: 20px;
          line-height: 2;
        }
      }

      .o2 {
        padding: 0 25px;
        line-height: 2;

        a {
          color: #ff8488;
        }

        i {
          font-size: 120%;
          color: #f6d200;
        }
      }
    }

    .rech {
      margin-top: 30px;
      border: 1px solid #fff;
      border-radius: 10px;
      background: rgba(156, 165, 236, 0.1);
      padding: 30px;
    }

    .payfangshi {
      #qrcode {
        height: 200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 60%;
        margin: 0 auto;
      }

      .saoma {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 60%;
        margin: 0 auto;

        div {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 200px;
          padding-top: 20px;

          img {
            height: 50px;
            margin-right: 8px;
            pointer-events: none;
          }

          i {
            display: block;
            font-size: 14px;
          }
        }
      }
    }
  }

  // 其他的
  i {
    font-style: normal;
  }

  p {
    margin: 0;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .kuang {
    display: block;
    width: 50px;
    height: 50px;
  }

  .Rechargeing .rech .payzh {
    font-size: 30px;
    font-family: MicrosoftYaHei;
    font-weight: bold;

    line-height: 100px;
    text-align: center;
  }

  .Rechargeing .rech div span {
    line-height: 100px;
    font-size: 30px;
    font-weight: bold;
  }

  .Rechargeing .rech .pay ul {
    /* overflow: hidden; */
    display: flex;
    /* justify-content: space-around; */
    flex-wrap: wrap;
  }

  .Rechargeing .rech .pay ul li {
    width: auto;
    position: relative;
    margin-right: 20px;
    margin-top: 20px;
  }

  .Rechargeing .rech .pay ul li b {
    display: block;
    margin-top: 25px;
    font-size: 24px;

    line-height: 40px;
  }

  // .Rechargeing .rech .payfangshi {
  //   display: flex;
  //   justify-content: space-around;
  //   margin: 30px 0;
  // }
  // .Rechargeing .rech .payfangshi .paylogo {
  //   width: 800px;
  //   display: flex;
  //   justify-content: space-around;
  // }
  // .Rechargeing .rech .payfangshi .paylogo img {
  //   width: 200px;
  //   height: 100px;
  // }
  // .Rechargeing .rech .payfangshi .wechat {
  //   width: 1200px;
  //   overflow: hidden;
  // }
  // .Rechargeing .rech .payfangshi .wechat .saoma {
  //   width: 800px;
  //   display: flex;
  //   justify-content: space-around;
  // }
  // .Rechargeing .rech .payfangshi .wechat .saoma i {
  //   display: block;
  //   width: 200px;
  //   font-size: 30px;
  //   font-weight: bold;

  //   line-height: 50px;
  //   text-align: center;
  //   margin: 10px 0;
  // }
  // .Rechargeing .rech .payfangshi .wechat span {
  //   font-size: 30px;
  //   font-weight: bold;

  //   line-height: 30px;
  // }
  // #qrcode {
  //   width: 800px;
  //   display: flex;
  //   justify-content: space-around;
  // }
  .Rechargeing .rech .miaoshu li {
    list-style: disc;
    font-size: 24px;

    line-height: 40px;
    margin-top: 10px;
  }

  /* 注册协议 */
}
</style>



// WEBPACK FOOTER //
// src/components/Rechargeing.vue